import React, { useState }  from 'react';
import TogglerBody from '../TogglerBody';
import ChooseActionTamplate from '../actionTamplate/ChooseActionTamplate';
import TipsTamplate from '../TipsTamplate';
import './flagCustomisation.scss'
import { statusActionsAdvanced } from '../../../constants/common'

const FlagCustomisationItemToggler = ({item, data}) => {
    const [currentAction, setCurrentAction] = useState(data && data[item.punishment] ? data[item.punishment] :'Kick')
    const [isTrigger, setIsTrigger] = useState(data ? data[item.trigger] : '')

    return (
        <div className='flag_customisation_item_wrap flag_customisation_item_wrap_toggler'>
            <div className='white_list_block_item_title_block flag_customisation_item_wrap_title'>
            <h4>{item.title}</h4>
            <TipsTamplate
                title={item.tipsTitle}
                label={item.label}
                text={item.text}
                textSecond={item.textSecond}
                />
            </div>
            <p>Status</p>

            <div className='status_block_item_toggler'>
                <TogglerBody
                    isOn={isTrigger}
                    setIsOn={setIsTrigger}
                    keyName={item.trigger}
                    advance
                />
                <p>{item.target}</p>
            </div>
            <p>Punishment</p>
            <ChooseActionTamplate
                keyName={item.punishment}
                currentAction={currentAction}
                setCurrentAction={setCurrentAction}
                actionArr={statusActionsAdvanced}
                advance
            />
        </div>
    );
};

export default FlagCustomisationItemToggler;